import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { FiMenu, FiX, FiArrowRight } from "react-icons/fi";
import site from "../data/site";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" }
];

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="container inner">
        <Link to="/" className="brand brand--logo" onClick={() => setOpen(false)} aria-label={site.brand}>
          <img src="/brand/atlas-logo.png" alt={site.brand} className="brand-logo" />
        </Link>

        <nav>
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) => (isActive ? "is-active" : "")}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="header-actions">
          <Link to="/contact" className="btn btn--dark">
            Start a project <FiArrowRight />
          </Link>
          <button
            className="burger"
            aria-label="Toggle menu"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="mobile-menu">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              onClick={() => setOpen(false)}
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            className="btn btn--dark"
            onClick={() => setOpen(false)}
            style={{ marginTop: "1rem", width: "100%", justifyContent: "center" }}
          >
            Start a project <FiArrowRight />
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;
